import React from "react";

import ReactJsPagination from "react-js-pagination";
import styled from "styled-components";

/**
 * 공용 페이지네이션. 기존 5종 StylePaginationComponent를 대체한다.
 * 부모가 page/pageSize/totalCount/onPageChange를 제어한다(프론트·서버 페이징 공통 계약).
 */
export function Pagination({
  page,
  pageSize,
  totalCount,
  onPageChange,
  pageRangeDisplayed = 5,
}) {
  if (!totalCount) return null;

  return (
    <Wrapper>
      <ReactJsPagination
        activePage={page}
        itemsCountPerPage={pageSize}
        totalItemsCount={totalCount}
        pageRangeDisplayed={pageRangeDisplayed}
        prevPageText={"‹"}
        nextPageText={"›"}
        firstPageText={"«"}
        lastPageText={"»"}
        onChange={onPageChange}
      />
    </Wrapper>
  );
}

export default Pagination;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ul.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    margin-top: 20px;
    padding: 0;

    li {
      margin: 0 5px;
      cursor: pointer;

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border: 1px solid #ccc;
        border-radius: 2px;
        background-color: white;
        color: #333333;
        text-decoration: none;

        &:hover {
          border: 1px solid var(--primary-6, #1890ff);
          background: var(--neutral-1, #fff);
        }
      }

      &.active a {
        border: 1px solid var(--primary-6, #1890ff);
        background: var(--neutral-1, #fff);
        color: var(--primary-6, #1890ff);
      }
    }
    font-family: "Noto Sans KR";
  }
`;
